module.exports = __webpack_public_path__ + "static/media/carro_1.cc4d35f8.webp";